import { useState } from 'react';

/**
 * Custom hook for managing organization creation modal state in AdminDashboard
 * 
 * @returns {Object} Object containing modal state and setters
 */
export const useOrganizationModalState = () => {
    // Create Organization modal states
    const [isCreateOrganizationOpen, setIsCreateOrganizationOpen] = useState(false);
    const [newOrganization, setNewOrganization] = useState({ id: '', name: '', rootAdminUserId: '' });
    const [organizationError, setOrganizationError] = useState('');
    const [organizationSaving, setOrganizationSaving] = useState(false);

    // Create Organization modal autocomplete search state
    const [ownerSearch, setOwnerSearch] = useState('');
    const [isOwnerDropdownOpen, setIsOwnerDropdownOpen] = useState(false);

    return {
        isCreateOrganizationOpen,
        setIsCreateOrganizationOpen,
        newOrganization,
        setNewOrganization,
        organizationError,
        setOrganizationError,
        organizationSaving,
        setOrganizationSaving,
        ownerSearch,
        setOwnerSearch,
        isOwnerDropdownOpen,
        setIsOwnerDropdownOpen
    };
};
